<script lang="ts">
    
    import { onDestroy } from "svelte";
    import type { Game } from "../../Model/Game";
    import { State } from "../../Model/State";
    import { SubscriptionsManager } from "../../Model/SubscriptionsManager";
    import Watch from "../Watch.svelte";
    import type { Cell } from "./types";

    export let game: Game;

    const cells: Cell[] = Array.from({ length: 90 }).map((...[, index]) => ({
        number: index + 1,
        hasComeOut: new State(false),
        isLastOne: new State(false),
    }));

    const gameSubscriptions = new SubscriptionsManager();

    $: setupGame(game);

    onDestroy(() => gameSubscriptions.unsubscribeAll());

    function setupGame(game: Game): void {
        gameSubscriptions.unsubscribeAll();

        if (!game) {
            cells.forEach(({ hasComeOut, isLastOne }) => {
                hasComeOut.set(false);
                isLastOne.set(false);
            });
            return;
        }

        gameSubscriptions.subscribe(game.numbers, numbers => {
            const [lastNumber] = numbers.slice(-1);
            cells.forEach(cell => {
                cell.hasComeOut.set(numbers.includes(cell.number));
                cell.isLastOne.set(lastNumber === cell.number);
            });
        });
    }

</script>

<div class="numbers-grid notranslate">
    {#each cells as { hasComeOut, isLastOne, number }}
        <Watch state={[hasComeOut, isLastOne]} let:value={[hasComeOut, isLastOne]}>
            <div class="cell font-bingo-number" class:has-come-out={hasComeOut} class:is-last-one={isLastOne}>
                <div class="number">{number}</div>
            </div>
        </Watch>
    {/each}
</div>


<style lang="scss">

    .numbers-grid {
        width: 100%;
        height: 100%;
        display: grid;
        grid-template-columns: repeat(9, 1fr);
        grid-template-rows: repeat(10, 1fr);
        grid-auto-flow: column;
        gap: 0.5rem;
        perspective: 500px;
    }

    .cell {
        background-color: #fff;
        color: #000;
        border-radius: 0.75vw;
        font-family: BingoNumber;
        font-size: 2.6vw;
        display: flex;
        justify-content: center;
        align-items: center;
        opacity: 0.25;
        transition-duration: 0.4s;
        transform: scale(0);

        &.has-come-out {
            opacity: 1;
        }

        &.is-last-one {
            background-color: var(--color-secondary);
        }
    }

    @for $i from 1 through 90 {
        .cell:nth-child(#{$i}) {
            animation: cell 0.3s cubic-bezier(.44,.15,.69,1.58) #{0.01s * $i} forwards;
        }
    }

    @keyframes cell {
        0% {
            transform: scale(0);
        }
        100% {
            transform: scale(1);
        }
    }

</style>

